import { Document } from "../models/document";

import BaseService from "./_base.service";

const endpoint = "documents";

const DocumentService = {
  ...BaseService<Document>({ endpoint })
};

export default DocumentService;
